import React, { useEffect, useState } from 'react'
import { HeadersPath } from '../../Utils/ScreenPath'
import { ACTIONS } from '../../redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import DynamicActionBar from '../../Common/DynamicActionBar'
import { useNavigate } from 'react-router-dom'
import { Api } from '../../Service/api'
import { ErrorToast } from '../../Common/Toast'
import moment from 'moment'
import PrintModel from '../../Common/PrintModel'
import { dynamicSequence } from '../../helper/dynamicSequence'
import { madeFinalObject } from '../../helper/madeFinalObject'

const RandomQuestions = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const RandomData = useSelector(state => state.RandomData?.RandomData)
    const [noticeData, setNoticeData] = useState([])
    const [askQue, setAskQue] = useState({})
    const [outOfQue, setOutOfQue] = useState({})
    const [withGeneralNotice, setWithGeneralNotice] = useState({})
    const [totalExamMark, setTotalExamMark] = useState(0)
    const [modelCall, setModelCall] = useState(false)
    const [isModelOpen, setisModelOpen] = useState(false)

    const handleBackClick = () => {
        navigate(-1)
    }



    const _getGenarateNotice = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                standard: RandomData?.standard?.id,
                semester: RandomData?.semester?.id,
                subject: RandomData?.subject?.id,
                chapter: RandomData?.chapter,
                medium: RandomData?.medium?.id,
                limit: 1000,
                offset: 1,
            }
            const { data } = await Api.GetNotices(JSON.stringify(params))
            const res = JSON.parse(data)
            if (res?.status === 200) {
                setNoticeData(res.data)
            } else {
                ErrorToast(res?.message)
            }
        } catch (e) {
            ErrorToast(e)
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    useEffect(() => {
        dispatch(ACTIONS.getHeaderPath(HeadersPath.RandomGenerate))
        _getGenarateNotice()
    }, [])

    const updateTotalExamMark = (askQueState) => {
        let total = 0;
        noticeData.forEach(notice => {
            const selectedAskQue = askQueState[notice.id] || 0;
            total += selectedAskQue * notice.mark;
        });
        setTotalExamMark(total);
    }

    const handleAskQueChange = (noticeId, value) => {
        const updatedAskQue = { ...askQue, [noticeId]: Number(value) }
        setAskQue(updatedAskQue)

        setOutOfQue(prevOutOfQue => {
            const newOutOfQue = { ...prevOutOfQue };
            if (!newOutOfQue[noticeId] || newOutOfQue[noticeId] < updatedAskQue[noticeId]) {
                newOutOfQue[noticeId] = updatedAskQue[noticeId];
            }
            return newOutOfQue;
        });

        updateTotalExamMark(updatedAskQue)
    }

    const handleOutOfQueChange = (noticeId, value) => {
        setOutOfQue(prev => ({ ...prev, [noticeId]: Number(value) }))
    }

    const handleWithGeneralNoticeChange = (noticeId, checked) => {
        setWithGeneralNotice(prev => ({ ...prev, [noticeId]: checked }))
    }

    const handleRandomPaperGenerate = async () => {
        if (totalExamMark > 1000) {
            ErrorToast("Total exam mark cannot be greater than 1000")
            return
        }

        const itemData = noticeData.map(notice => ({
            id: notice.id,
            qtype: notice.qtype,
            askQue: askQue[notice.id] || 0,
            outOfQue: outOfQue[notice.id] || 0,
            isGeneralNotice: withGeneralNotice[notice.id] || false,
        }))
        const selectedData = itemData?.filter((item) => item?.askQue > 0);
        let data = selectedData.map((item) => {
            return {
                notice_id: item?.id,
                qtype_id: item?.qtype,
                ask_que: item?.askQue,
                out_of_que: item?.outOfQue,
                isGeneralNotice: item?.isGeneralNotice,
            };
        });


        const withOutSection = [
            {
                section_id: 1,
                section_name: 'A',
                divisions: data,
            },
        ];

        let withSection = selectedData.map((item, index) => {
            return {
                section_id: index + 1,
                section_name: `Section - ${String.fromCharCode(index + 65)}`,
                divisions: [
                    {
                        notice_id: item?.id,
                        qtype_id: item?.qtype,
                        ask_que: item?.askQue,
                        out_of_que: item?.outOfQue,
                        isGeneralNotice: item?.isGeneralNotice,
                    },
                ],
            };
        });


        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                standard: RandomData?.standard?.id,
                semester: RandomData?.semester?.id,
                subject: RandomData?.subject?.id,
                chapter: RandomData?.chapter,
                medium: RandomData?.medium?.id,
                section_info: RandomData?.withSection ? withSection : withOutSection,
            };
            const { data } = await Api.GetRandomQuestionList(JSON.stringify(params))
            const res = JSON.parse(data);
            if (res?.status === 200) {
                let FinalObject = madeFinalObject(res?.data, false)
                let dataObject = dynamicSequence(FinalObject);
               
                if (res?.data.length > 0) {
                    const data = {
                        institute_logo: '',
                        school_name: '',
                        template_name: '',
                        exam_name: '',
                        chapter_name: '',
                        exam_time: '',
                        exam_marks: totalExamMark,
                        medium: RandomData?.medium?.id,
                        exam_date: moment(new Date()).format('DD/MM/YYYY'),
                        paper_type: 'random',
                        genrate_type: RandomData?.withSection
                            ? 'with section'
                            : 'without section',
                        standard_id: RandomData?.standard?.id,
                        standard_name: RandomData?.standard?.name,
                        subject_id: RandomData?.subject?.id,
                        subject_name: RandomData?.subject?.subject,
                        semester_id: RandomData?.semester?.id,
                        semester_name: RandomData?.semester?.semester,
                        sections_info: dataObject,
                    }
                    dispatch(ACTIONS.getSelectedData(data))
                    setisModelOpen(!isModelOpen)
                    setModelCall(true)
                }

            } else {
                ErrorToast(res?.message);
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    };

    const handleModelClose = () => {
        setisModelOpen(!isModelOpen)
    }
    const actions = [
        { label: "Random Paper Generate", onClick: handleRandomPaperGenerate, disabled: totalExamMark == 0 },
    ]

    return (
        <div className="container mx-auto">
            <DynamicActionBar
                showArrowLeft
                backButtonLabel={"Random Generate Questions"}
                onBackClick={handleBackClick}
                actions={actions}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0px',position: 'sticky',top: '69px',backgroundColor: '#F6F7F9' }} className='text-sm md:text-base font-medium'>
                <div>Subject : English</div>
                <div>Total Exam Mark : {totalExamMark} </div>
            </div>
            {noticeData?.length > 0 && noticeData.map(notice => (
                <div className="mt-4 bg-white shadow-md rounded-lg md:p-6 p-4">
                    <div key={notice.id} className="mb-6">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-sm md:text-base font-medium">{notice.notice}</h2>
                            <span className="text-xs md:text-sm text-gray-600 w-1/3 text-end">( Mark - {notice.mark} )</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0px', gap: '10px' }}>
                            <div style={{ width: '-webkit-fill-available' }}>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Ask Que.</label>
                                <select
                                    value={askQue[notice.id] || 0}
                                    onChange={(e) => handleAskQueChange(notice.id, e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                                >
                                    {[...Array(notice.questionCount + 1 || 0)].map((_, i) => (
                                        <option key={i} value={i}>{i}</option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ width: '-webkit-fill-available' }}>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Out of Que.</label>
                                <select
                                    value={outOfQue[notice.id] || askQue[notice.id] || 0}
                                    onChange={(e) => handleOutOfQueChange(notice.id, e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                                >
                                    {[...Array((notice.questionCount + 1 - (askQue[notice.id] || 1)) || 0)].map((_, i) => (
                                        <option key={i} value={i + (askQue[notice.id] || 0)}>{i + (askQue[notice.id] || 0)}</option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ width: '-webkit-fill-available' }}>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Total Que.</label>
                                <div className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-600">
                                    {notice.questionCount || ''}
                                </div>
                            </div>
                        </div>
                        {outOfQue[notice.id] > askQue[notice.id] && (
                            <div className="mt-4">
                                <label className="flex items-center">
                                    <input
                                        type="checkbox"
                                        checked={withGeneralNotice[notice.id] || false}
                                        onChange={(e) => handleWithGeneralNoticeChange(notice.id, e.target.checked)}
                                        className="form-checkbox h-5 w-5 text-blue-600"
                                    />
                                    <span className="ml-2 text-sm text-gray-700">With General Notice</span>
                                </label>
                            </div>
                        )}
                    </div>
                </div>
            ))}

            <PrintModel
                isModelOpen={isModelOpen}
                setisModelOpen={setisModelOpen}
                handleModelClose={handleModelClose}
                modelCall={modelCall}
                setModelCall={setModelCall}
                headerPath={HeadersPath.RandomGenerate}
            />
        </div>
    )
}

export default RandomQuestions
